<template>
	<div class="margin-left">
		<div class="top text-left flex justify-between align-center">
			<div class="flex align-center top-type flex-sub">
				<p v-for="(item,iudc) in toplist" class="flex-sub pointer text-center" @click="choseindc(item.type)" :key="iudc" :class="topindex == item.type?'text-theme active':''">{{item.name}}</p>
			</div>
			<p>
				<!-- <el-date-picker v-model="month" type="month" prefix-icon=' ' placeholder="选择月" @change="chose">
				</el-date-picker> -->
			</p>
		</div>
		<div>
			<div class="" v-if="total != 0">
				<div class=" bg-white list  margin-top">
					<div class="padding solid-bottom" v-for="(item,index) in integral" :key="index">
						<div class="flex align-center justify-between">
							<div class="flex flex-direction align-start justify-between">
								<p class="text-df text-333">{{item.description}}</p>
								<p class="margin-top-sm text-sm text-ccc">{{item.create_time}}</p>
							</div>
							<p class="text-bold fs22 text-theme">{{topindex == 1?'+':'-'}} {{item.integral}}</p>
						</div>
					</div>
				</div>
				<div class="pagination padding-bottom">
					<el-pagination
					@current-change="handleCurrentChange"
					  background
					  layout="prev, pager, next"
					  prev-text="上一页"
					  next-text="下一页"
					  :total="total">
					</el-pagination>
				</div>
			</div>
			<div class="text-center" v-else>
				<el-empty description="暂无数据"></el-empty>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				month: '',//选择的月份
				toplist:[
					{
						name:'积分获取记录',
						type:1
					},{
						name:'积分消耗记录',
						type:0
					}
				],//类型
				topindex:1,//选中的类型下标
				page:1,
				total:0,//
				integral:[]
			};
		},
		created() {
			this.getlist()
		},
		methods:{
			/**
			 * 选择类型
			 * */
			choseindc(iudc){
				this.topindex = iudc
				this.integral = []
				this.page = 1
				this.getlist();
			},
			/**
			 * 选择月
			 * */
			chose(){
				
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getlist();
			},
			// 积分记录
			getlist(){
				this.ajax('get', '/api/integral/getMyIntegralList', {
					// time:this.year+'-'+this.month,
					status:this.topindex,
					page:this.page
				},res => {
					this.integral = res.data.data
					if(this.page == 1){
						this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
					}
				})
			}
		}
	};
</script>

<style scoped lang="less">
	
	/deep/ .el-input__inner {
		border: 0;
		height: 69px !important;
		font-size: 18px;
	}
	.list{
		width: 921px;
		box-shadow: 0px 2px 51px 0px rgba(34,34,34,0.08);
		border-radius: 20px;
	}
	.top{
		width: 921px;
		height: 69px;
		line-height: 69px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 10px;
	}
	.active{
		position: relative;
		&:after{
			width: 27px;
			height: 6px;
			background: #0B837C;
			border-radius: 3px;
			content: '';
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
		}
	}
	.top-type{
		width: 600px;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/integral/record.vue